/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MetricDataSourceRefRep = {
  key: string;
  environmentKey?: string | undefined;
  name?: string | undefined;
  integrationKey?: string | undefined;
};

/** @internal */
export const MetricDataSourceRefRep$inboundSchema: z.ZodType<
  MetricDataSourceRefRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  environmentKey: z.string().optional(),
  _name: z.string().optional(),
  _integrationKey: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "_name": "name",
    "_integrationKey": "integrationKey",
  });
});
/** @internal */
export type MetricDataSourceRefRep$Outbound = {
  key: string;
  environmentKey?: string | undefined;
  _name?: string | undefined;
  _integrationKey?: string | undefined;
};

/** @internal */
export const MetricDataSourceRefRep$outboundSchema: z.ZodType<
  MetricDataSourceRefRep$Outbound,
  z.ZodTypeDef,
  MetricDataSourceRefRep
> = z.object({
  key: z.string(),
  environmentKey: z.string().optional(),
  name: z.string().optional(),
  integrationKey: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    name: "_name",
    integrationKey: "_integrationKey",
  });
});

export function metricDataSourceRefRepToJSON(
  metricDataSourceRefRep: MetricDataSourceRefRep,
): string {
  return JSON.stringify(
    MetricDataSourceRefRep$outboundSchema.parse(metricDataSourceRefRep),
  );
}
export function metricDataSourceRefRepFromJSON(
  jsonString: string,
): SafeParseResult<MetricDataSourceRefRep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetricDataSourceRefRep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetricDataSourceRefRep' from JSON`,
  );
}
